import { useState } from 'react'
import { ChevronDown } from 'lucide-react'

export default function FestivalCard({ festival }) {
  const [expanded, setExpanded] = useState(false)

  return (
    <div className="bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 border border-gold/10">
      <div className="bg-gradient-to-r from-saffron to-saffron-light px-5 py-3 flex items-center justify-between">
        <span className="text-white/80 text-xs font-semibold uppercase tracking-widest">{festival.month}</span>
        <span className="text-gold text-xs font-medium">{festival.duration}</span>
      </div>
      <div className="p-5">
        <h3 className="font-display text-xl font-bold text-charcoal mb-1">{festival.name}</h3>
        <p className="font-tamil text-saffron text-sm mb-3">{festival.tamilName}</p>
        <p className="text-charcoal-soft text-sm leading-relaxed line-clamp-2">{festival.significance}</p>

        {festival.details && (
          <div>
            <button
              onClick={() => setExpanded(!expanded)}
              className="mt-3 flex items-center gap-1 text-saffron text-sm font-semibold hover:text-saffron-dark transition-colors"
            >
              View Details
              <ChevronDown size={14} className={`transition-transform ${expanded ? 'rotate-180' : ''}`} />
            </button>
            {expanded && (
              <div className="mt-3 pt-3 border-t border-gold/20 text-charcoal-soft text-sm leading-relaxed">
                {festival.details}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  )
}
